/** @module Classes */ /** typedoc */
/**
 * Represents the state of a task in progress.
 * The task can be started from the frontend or backend,
 * and can be updated from both frontend (eg: upload) or backend (eg: master).
 * Each task always have a specific current name to follow step machine evolution,
 * and the internal progress of the current step.
 * When failed a message property indicates the reason.
 */
class State {
    /**
     * Create a State with at least a name.
     * @param {T} name Step name of state based on the `T` State enum.
     * Can be one of [[StateUploadingAndSamplingEnum]], [[StateUploadingAndPreparingEnum]],
     * [[StateSamplingEnum]], [[StateMasteringEnum]], [[StateTranscodingEnum]], or [[StatePendingEnum]]
     * @param {number} progress Indicates the progress from 0 to 100.
     * @param {string} message Additional message for `Failed` states.
     */
    constructor(name, progress = 0, message = '') {
        this.name = name;
        this.progress = progress;
        this.message = message;
    }
}

export { State };
